import { Component, OnInit } from '@angular/core';
import {PriorityService} from '../../services/priority.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalExtended} from 'ngx-dynamic-modal';
import {AuthService} from '../../../../../core/service/auth.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

import * as _ from 'underscore';

@Component({
  selector: 'app-edit-priority',
  templateUrl: './edit-priority.component.html',
  styleUrls: ['./edit-priority.component.scss']
})
export class EditPriorityComponent extends ModalExtended implements OnInit {

    data: Object;
    formData: FormGroup;
    loading: boolean = false;

    constructor(private priorityService: PriorityService, private fb: FormBuilder, private auth: AuthService, private alerts: AlertaService) {
        super();
        this.formData = this.fb.group({
            'all_portals' : new FormControl('0'),
            'service_pk' : new FormControl('', Validators.required),
            'service_campaign_pk' : new FormControl(''),
            'text' : new FormControl('', Validators.required),
            'priority' : new FormControl(0, Validators.required),
            'config' : new FormControl(),
            'active' : new FormControl('0')
        });
    }

    savePriority(): void {
        this.loading = true;
        let data = Object.assign({}, this.formData.value);
        if(!data.hasOwnProperty('all_portals') || (data.hasOwnProperty('all_portals') && data.all_portals == "0")){
            data['portal_pk'] = this.auth.getPkPortal();
        }

        delete data['all_portals'];
        this.priorityService.postPriority(data).subscribe(
            (r) => {
                this.data['object'] = r.data;
                this.data['type'] = 'edit';
                this.loading = false;
                this.alerts.addAlert('success', 'Created successfully. Now you can update it it you forgot something');
            }
        )
    }

    updatePriority(): void {
        this.loading = true;
        let data = Object.assign({}, this.formData.value);
        if(!data.hasOwnProperty('all_portals') || (data.hasOwnProperty('all_portals') && data.all_portals == "0")){
            data['portal_pk'] = this.auth.getPkPortal();
        }

        delete data['all_portals'];
        this.priorityService.putPriority(this.data['object']['pk'], data).subscribe(
            (r) => {
                this.loading = false;
                this.alerts.addAlert('success', 'Updated successfully');
            }
        )
    }

    onExit(): void {
        this.applyCallback(true);
        this.close();
    }

    ngOnInit() {
        if(this.data.hasOwnProperty('object')){
            this.loading = true;
            const editObject = this.data['object'];
            this.formData.controls['service_pk'].setValue(editObject['service_pk']);
            this.formData.controls['service_campaign_pk'].setValue(editObject['service_campaign_pk']);
            this.formData.controls['text'].setValue(editObject['text']);
            this.formData.controls['priority'].setValue(editObject['priority']);
            this.formData.controls['active'].setValue(editObject['active']);

            (!_.isEmpty(editObject['config']))
                ? this.formData.controls['config'].setValue(editObject['config'])
                : this.formData.controls['config'].setValue({})
            ;

            if(_.isEmpty(editObject['portal_pk'])){
                this.formData.controls['all_portals'].setValue('1');
            }

            this.loading = false;

        }
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/priorities/modals/edit-priority/edit-priority.component.ts